import React from 'react';
import propTypes from 'prop-types';
import { workDriveEmbedSrc } from 'helpers/tableSpecialCells/embedding';

function CarrierDetailResources({
  carrier,
  fillHeight = false,
  showSubheading = true
}) {
  if (!carrier?.workDriveFolderURL) return null;

  return (
    <section className={fillHeight ? 'flex min-h-0 flex-1 flex-col' : 'block'}>
      {showSubheading && (
        <h3 className='mb-3 text-sm font-semibold text-gray-700'>
          Carrier Resources
        </h3>
      )}
      <iframe
        title='Work Drive Folder'
        allowFullScreen
        className={
          fillHeight
            ? 'min-h-0 w-full flex-1 rounded-md border-none'
            : 'h-[50dvh] w-full rounded-md border-none'
        }
        src={workDriveEmbedSrc(carrier.workDriveFolderURL)}
      />
    </section>
  );
}

CarrierDetailResources.propTypes = {
  carrier: propTypes.object.isRequired,
  fillHeight: propTypes.bool,
  showSubheading: propTypes.bool
};

export default CarrierDetailResources;
